import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BACKEND_URL } from "./backendconfig";
import { usePublicList } from "./usePublicList";
import "./FreeDemo.css";

const backend = BACKEND_URL.replace(/\/+$/, "");

function resolveBackendUrl(path) {
  return path ? new URL(path, `${backend}/`).href : "";
}

export default function FreeDemo() {
  const { items, loading, error } = usePublicList(
    `${backend}/media.php?type=free-demo`
  );

  const [selectedId, setSelectedId] = useState("");
  const [failedThumbnailId, setFailedThumbnailId] = useState("");
  const [playerUrl, setPlayerUrl] = useState("");

  const selected =
    items.find((item) => item.id === selectedId) || items[0];

  const thumbnailUrl = resolveBackendUrl(selected?.thumbnail);

  const showThumbnail = Boolean(
    thumbnailUrl && failedThumbnailId !== selected?.id
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const selectTopic = (item) => {
    setPlayerUrl("");
    setSelectedId(item.id);
    setFailedThumbnailId("");
  };

  const openVideo = () => {
    if (!selected) return;

    const params = new URLSearchParams({
      id: selected.id,
      title: selected.title,
      embed: "1",
    });

    setPlayerUrl(`${backend}/watch.php?${params.toString()}`);
  };

  return (
    <main className="ltc-free-demo-page">
      <section className="ltc-free-demo-section">
        <div className="ltc-free-demo-container">
          <div className="ltc-free-demo-heading">
            <span className="ltc-free-demo-eyebrow">
              WATCH & LEARN
            </span>

            <h1 className="ltc-free-demo-title">
              Free Demo Classes
            </h1>

            <p className="ltc-free-demo-description">
              Select a topic below to watch it free.
            </p>

            <Link
              to="/#courses"
              className="ltc-free-demo-back-link"
            >
              ← Back to courses
            </Link>
          </div>

          {loading && (
            <p className="ltc-free-demo-message" role="status">
              Loading demo topics…
            </p>
          )}

          {error && (
            <p
              className="ltc-free-demo-message ltc-free-demo-message-error"
              role="alert"
            >
              {error}
            </p>
          )}

          {!loading && !error && !items.length && (
            <p className="ltc-free-demo-message">
              No demo videos available yet.
            </p>
          )}

          {!loading && !error && selected && (
            <div className="ltc-free-demo-layout">
              <nav
                className="ltc-free-demo-topics"
                aria-label="Free demo topics"
              >
                <h3 className="ltc-free-demo-topics-heading">
                  All Demo Topics ({items.length})
                </h3>

                <div className="ltc-free-demo-topic-list">
                  {items.map((item, index) => {
                    const active = item.id === selected.id;

                    return (
                      <button
                        type="button"
                        key={item.id}
                        className={`ltc-free-demo-topic-button${
                          active
                            ? " ltc-free-demo-topic-button-active"
                            : ""
                        }`}
                        aria-current={active ? "true" : undefined}
                        onClick={() => selectTopic(item)}
                      >
                        <span className="ltc-free-demo-topic-number">
                          {String(index + 1).padStart(2, "0")}
                        </span>

                        <span className="ltc-free-demo-topic-title">
                          {item.title}
                        </span>
                      </button>
                    );
                  })}
                </div>
              </nav>

              <div className="ltc-free-demo-player">
                <div className="ltc-free-demo-screen">
                  {playerUrl ? (
                    <iframe
                      key={playerUrl}
                      src={playerUrl}
                      title={selected.title}
                      className="ltc-free-demo-iframe"
                      allow="autoplay; fullscreen; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <button
                      type="button"
                      className="ltc-free-demo-preview"
                      onClick={openVideo}
                      aria-label={`Watch ${selected.title}`}
                    >
                      {showThumbnail && (
                        <img
                          key={selected.id}
                          src={thumbnailUrl}
                          alt=""
                          className="ltc-free-demo-thumbnail"
                          onError={() =>
                            setFailedThumbnailId(selected.id)
                          }
                        />
                      )}

                      <span className="ltc-free-demo-preview-overlay">
                        <span
                          className="ltc-free-demo-play-icon"
                          aria-hidden="true"
                        >
                          ▶
                        </span>

                        <span className="ltc-free-demo-play-label">
                          Watch Free Demo
                        </span>
                      </span>
                    </button>
                  )}
                </div>

                <h2 className="ltc-free-demo-video-title">
                  {selected.title}
                </h2>
              </div>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}